/**
 * Generic element that displays a button (which looks like a link actually)
 * that lets the user add some child item to the current box.
 * Used for example in the generic template to add a button to a button group,
 * and in the list template to add a list item to the template.
 * 
 * It expects an 'addChildClicked' method on the parent cell's view,
 * and calls it when clicked, passing it a unique id (just fetched from the backend)
 * and a reference that the parent may or may not have set in its model property 'addChildId'
 * in case several AddChild buttons are present in a given Box
 * For example for the generic template, the reference is the carouselId of the element 
 * to which this AddChild child should add a messegner button;
 * whereas the media and button templates only have one 'add button' button and hence don't need this mechanism.
 * 
 * The 'add something' label should be set in the 'label' model property,
 * and the button can be disabled by setting the 'disabled' property
 * (for example for a carousel element only 3 buttons are allowed)
 */
export function AddChildViewConstructor(services, callbacks, context, siteTypeConfig) {
  
  let joint = services.joint;
  let companyId = context.companyId;
  let siteId = context.site.id;
  let scenarioId = context.scenarioId;

  return joint.shapes.html.AbstractElementView.extend({

    template: [
      '<div class="html-element add-item-to-parent">',
      '  <button class="center-block btn btn-alcmeon-default"></button>',
      '</div>'
    ].join(''),

    initialize: function() {
      joint.shapes.html.AbstractElementView.prototype.initialize.apply(this, arguments);

      // this.$box is initialized by the abstract superclass
      this.$box.find('button').text(this.model.get('label'));
      this.$box.find('button').on('click', () => this.addChildClicked());
    },

    addChildClicked: function(evt) {
      if (!this.model.get('disabled')) {
        services.QuickRepliesFactory.createUniqueId(companyId, siteId, scenarioId)
        .then(response => {
          let parent = this.model.getAncestors()[0];
          let parentView = this.paper.findViewByModel(parent);
          parentView.addChildClicked(response.data.id, this.model.get('addChildId'));
        }, 
        services.AlertingFactory.httpErrorHandler());
      }
    },

    updateBox: function() {
      if(this.paper) {
        this.$box.find('button').prop('disabled', this.model.get('disabled'));
      }
      joint.shapes.html.AbstractElementView.prototype.updateBox.apply(this, arguments);
    },

  });
}
